import { forwardRef, Ref, type SVGProps } from 'react';

const SvgArrowNarrowRightIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 9.333"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M.667 4.667h10.666m-4 4 4-4-4-4"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgArrowNarrowRightIcon);
export default ForwardRef;
